export const preferredBillingCycleDayList = [
  {
    value: 99,
    label: "None",
    id: 99,
  },
  {
    value: 1,
    label: "1st",
    id: 1,
  },
  {
    value: 2,
    label: "2nd",
    id: 2,
  },
  // objects  3-28
  {
    value: 3,
    label: "3rd",
    id: 3,
  },
  {
    value: 4,
    label: "4th",
    id: 4,
  },
  {
    value: 5,
    label: "5th",
    id: 5,
  },
  {
    value: 6,
    label: "6th",
    id: 6,
  },
  {
    value: 7,
    label: "7th",
    id: 7,
  },
  {
    value: 8,
    label: "8th",
    id: 8,
  },
  {
    value: 9,
    label: "9th",
    id: 9,
  },
  {
    value: 10,
    label: "10th",
    id: 10,
  },
  {
    value: 11,
    label: "11th",
    id: 11,
  },
  {
    value: 12,
    label: "12th",
    id: 12,
  },
  {
    value: 13,
    label: "13th",
    id: 13,
  },
  {
    value: 14,
    label: "14th",
    id: 14,
  },
  {
    value: 15,
    label: "15th",
    id: 15,
  },
  {
    value: 16,
    label: "16th",
    id: 16,
  },
  {
    value: 17,
    label: "17th",
    id: 17,
  },
  {
    value: 18,
    label: "18th",
    id: 18,
  },
  {
    value: 19,
    label: "19th",
    id: 19,
  },
  {
    value: 20,
    label: "20th",
    id: 20,
  },
  {
    value: 21,
    label: "21st",
    id: 21,
  },
  {
    value: 22,
    label: "22nd",
    id: 22,
  },
  {
    value: 23,
    label: "23rd",
    id: 23,
  },
  {
    value: 24,
    label: "24th",
    id: 24,
  },
  {
    value: 25,
    label: "25th",
    id: 25,
  },
  {
    value: 26,
    label: "26th",
    id: 26,
  },
  {
    value: 27,
    label: "27th",
    id: 27,
  },
  {
    value: 28,
    label: "28th",
    id: 28,
  },
];
